import type { SiteReportRecipients } from '../../services/sitesService';

/**
 * Jim 10/21: on a site's first inspection in the app, show who the report
 * goes to — "these are the people getting the emails… is this accurate?" —
 * once. The site's own count of app-filed inspections ends it for good;
 * a confirmation on this device ends it for an abandoned flow.
 */
const key = (siteId: string) => `lite.recipients.ok.${siteId}`;

type Store = Pick<Storage, 'getItem' | 'setItem'>;

function storage(): Store | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

export function recipientsPromptNeeded(
  data: SiteReportRecipients | undefined,
  siteId: string,
  store: Store | null = storage()
): boolean {
  if (!data || data.app_inspections > 0) return false;
  try {
    return store?.getItem(key(siteId)) !== '1';
  } catch {
    return true;
  }
}

export function rememberRecipientsOk(
  siteId: string,
  store: Store | null = storage()
): void {
  try {
    store?.setItem(key(siteId), '1');
  } catch {
    /* a private window: the prompt simply shows again next time */
  }
}
